import axios from "axios";
import Vue from "vue";
export const state = {
  categories: [],
  expenses: [],
  report: [],
  details_report: [],
  expense_details: [],
  expense_cart: [],
  expense_budget: [],
  expense_items: [],
  suppliers: [],
  creditors: [],
  tot_cart: 0,
  save_status: false,
};
export const getters = {
  Categories: (state) => state.categories.data,
  ExpenseCart: (state) => state.expense_cart.data,
  Expenses: (state) => state.expenses.data,
  ExpenseDetail: (state) => state.expense_details.data,
  Creditors: (state) => state.creditors.data,
  ExpenseItems: (state) => state.expense_items,
  TotCart: (state) => state.tot_cart,
  Suppliers: (state) => state.suppliers.data,
  Report: (state) => state.report,
  DetailReport: (state) => state.details_report,
  SaveStatus: (state) => state.save_status,
};

export const mutations = {
  SET_CATS(state, newValue) {
    state.categories = newValue;
  },
  SET_CART(state, newValue) {
    state.expense_cart = newValue;
  },
  SET_EXPENSES(state, newValue) {
    state.expenses = newValue;
  },
  SET_TOT(state, newValue) {
    state.tot_cart = newValue;
  },
  SET_EXPENSE_ITEMS(state, newValue) {
    state.expense_items = newValue;
  },
  SET_SUPPLIERS(state, newValue) {
    state.suppliers = newValue;
  },
  SET_CREDITORS(state, newValue) {
    state.creditors = newValue;
  },
  SET_EXPENSE(state, newValue) {
    state.expense_details = newValue;
  },
  SET_REPORT(state, newValue) {
    state.report = newValue;
  },
  SET_DREPORT(state, newValue) {
    state.report = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  pushNotification(state, payload) {
      Vue.notify({
        type: payload.type,
        group: "foo",
        title: payload.title,
        text: payload.message,
        position: "bottom right",
        duration: 10000,
        speed: 500,
      });
    },
};

export const actions = {
  addExpCategory({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("expense_categories", payload)
      .then(() => {
        dispatch("fetchExpCategories");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  addExpItem({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("expense_items", payload)
      .then(() => {
        dispatch("fetchExpCategories");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Edit  Set
  editExpCategory({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`expense_categories/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchExpCategories");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Delete Set
  deleteExpCategory({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`expense_categories/${payload.id}`)
      .then(() => {
        dispatch("fetchExpCategories");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  deleteExpItem({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`expense_items/${payload.id}`)
      .then(() => {
        dispatch("fetchExpCategories");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  addToCart({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("expense_cart", payload)
      .then(() => {
        dispatch("fetchExpenseCart");
        dispatch("fetchExpenseCartTot");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Edit  Set
  editCart({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`expense_cart/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchExpenseCart");
        dispatch("fetchExpenseCartTot");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Delete Set
  deleteCart({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`expense_cart/${payload.id}`)
      .then(() => {
        dispatch("fetchExpenseCart");
        dispatch("fetchExpenseCartTot");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },

  addExpense({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("expenses", payload)
      .then(() => {
        dispatch("fetchExpenses");
        dispatch("fetchExpenseCart");
        dispatch("fetchExpenseCartTot");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  deleteExpense({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("delete_exp", payload)
      .then(() => {
        dispatch("fetchExpenses");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  clearCredit({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("clear_credit", payload)
      .then(() => {
        dispatch("fetchExpenses");
        dispatch("fetchCreditors");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },

  addSupplier({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("suppliers", payload)
      .then(() => {
        dispatch("fetchSuppliers");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Edit  Set
  editSupplier({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`suppliers/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchSuppliers");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Delete Set
  deleteSupplier({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`suppliers/${payload.id}`)
      .then(() => {
        dispatch("fetchSuppliers");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },

  exportExpenses({ commit }, payload) {
      commit("SET_SAVE_STATUS", true);
      axios({
        url: "/export_expenses",
        method: "post",
        data: payload,
        responseType: "blob",
      })
        .then((response) => {
          commit("SET_SAVE_STATUS", false);
          // Create a new Blob object using the response data
          const file = new Blob([response.data], {
            type: "application/pdf",
          });
  
          // Create a URL for the file
          const fileURL = URL.createObjectURL(file);
  
          // Open the PDF in a new tab
          const newWindow = window.open(fileURL);
  
          // Wait for the file to load before triggering the print dialog
          if (newWindow) {
            newWindow.onload = function() {
              newWindow.focus();
              newWindow.print();
            };
          }
        })
        .catch((error) => {
          commit("SET_SAVE_STATUS", false);
          let message = {
            type: "error",
            title: "<b>Error Occured</b>",
            message: "Unexpected Error Occured",
          };
          if (error.response.status == 422) {
            const errorData = error.response.data;
            message.title = "<b>" + errorData.msg + "</b>";
            message.message = errorData.error;
          }
          commit("pushNotification", message);
        });
    },

  fetchExpCategories({ commit }) {
    axios.get("expense_categories").then((pos) => {
      commit("SET_CATS", pos.data);
    });
  },
  fetchExpenses({ commit }) {
    axios.get("expenses").then((sta) => {
      commit("SET_EXPENSES", sta.data);
    });
  },
  fetchExpense({ commit }, id) {
    axios.get(`expenses/${id}`).then((sta) => {
      commit("SET_EXPENSE", sta.data);
    });
  },
  fetchExpenseCart({ commit }) {
    axios.get("expense_cart").then((sta) => {
      commit("SET_CART", sta.data);
    });
  },
  fetchExpenseCartTot({ commit }) {
    axios.get("cart_tot").then((sta) => {
      commit("SET_TOT", sta.data);
    });
  },
  fetchExpenseItems({ commit }) {
    axios.get("expense_items").then((sta) => {
      commit("SET_EXPENSE_ITEMS", sta.data);
    });
  },
  fetchSuppliers({ commit }) {
    axios.get("suppliers").then((pos) => {
      commit("SET_SUPPLIERS", pos.data);
    });
  },
  fetchCreditors({ commit }) {
    axios.get("creditors").then((pos) => {
      commit("SET_CREDITORS", pos.data);
    });
  },
  fetchReport({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("expense_report", payload)
      .then((sta) => {
        commit("SET_REPORT", sta.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
  fetchDetailReport({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("expense_detail_report", payload)
      .then((sta) => {
        commit("SET_DREPORT", sta.data);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
      });
  },
};
